"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandArrow = exports.Collapse = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var React = _interopRequireWildcard(require("react"));
var _reactCollapse = require("react-collapse");
var _icons = require("../icons");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-collapse'. 'node_modules/react-collapse/lib/index.js' implicitly has an 'any' type.
var Collapse = exports.Collapse = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Collapse, _React$Component);
  var _super = _createSuper(Collapse);
  function Collapse() {
    (0, _classCallCheck2["default"])(this, Collapse);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(Collapse, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(CollapseAnimation, {
        id: this.props.id,
        className: this.props.className
      }, /*#__PURE__*/React.createElement(_reactCollapse.Collapse, {
        isOpened: this.props.isOpened
      }, this.props.children));
    }
  }]);
  return Collapse;
}(React.Component);
var ExpandArrow = exports.ExpandArrow = function ExpandArrow(_ref) {
  var expanded = _ref.expanded,
    ariaControls = _ref['aria-controls'],
    className = _ref.className;
  var Arrow = expanded ? _icons.UpArrow : _icons.DownArrow;
  return /*#__PURE__*/React.createElement(Arrow, {
    className: className,
    "aria-controls": ariaControls,
    "aria-expanded": expanded
  });
};
var CollapseAnimation = _styledComponents["default"].div.withConfig({
  displayName: "collapse__CollapseAnimation"
})([".ReactCollapse--collapse{transition:height 500ms cubic-bezier(0.21,0.61,0.3,1);}"]);